export enum VerificationProcessEnum {
  IRIS='iris',
  FINGERPRINT='finger-print',
  FACIAL='facial',
  AADHAR_FINGER='aadhar-finger',
  AADHAR_IRIS='aadhar-iris',
  AADHAR_FACE='aadhar-face',
}
